import {
  BothVisibilitySelects,
  PlaceValueCheckboxes,
  Labels,
  AdvancedSettingsPanel,
  MaxLength,
  FieldMask,
  EmailBodyVisibilitySelect,
} from 'apps/studio/components/settings/fields/Base/advanced'
import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

export const MobileStyle = {
    label: 'Mobile Style',
    settingType: 'selectInput',
    property: 'style',
    choices: [
        {
            label: 'Small',
            value: 2,
        },
        {
            label: 'Normal',
            value: 0,
        },
        {
            label: 'Large',
            value: 1,
        },
    ],
}


export const TextAdvancedSettings = AdvancedSettingsPanel([
  SettingsLabel('Config'),
  MaxLength,
  FieldMask,
  ...BothVisibilitySelects,
  ...PlaceValueCheckboxes,
  ...Labels,
])

export const LongTextAdvancedSettings = AdvancedSettingsPanel([
  SettingsLabel('Config'),
  MobileStyle,
  ...BothVisibilitySelects,
  SettingsLabel('Place Value In'),
  EmailBodyVisibilitySelect,
  ...Labels,
])
